<template>
    <div class="form-default" v-if="formSetUp != null">
        <Form class="form_call" @submit="onSubmit" :validation-schema="schema" v-slot="{ errors, values }" v-if="formVisible && !toManySendingMsg">
            <div class="form-in" :class="{'disabled-form' : formDisabled}">
               <TextInput
                    name="name"
                    type="text"
                    :placeholder="formSetUp.inputname"
                    class="form-group-flats"
                    :class="{'error' : errors.name}"
                />
                <TextInput
                    name="phone"
                    type="text"
                    :placeholder="formSetUp.inputphone"
                    v-maska="'+7 (###) ###-##-##'"
                    class="form-group-flats"
                    :class="{'error' : errors.phone}"
                />
                <div ref="turnstileContainer" v-show="turnstileVisible" style="margin: 8px 0;"></div>
                <div class="btn-send">
                    <button
                        class="btn btn-submit btn-success"
                        type="submit"
                        :disabled="!isFormReady(errors, values)"
                    >
                        {{ formSetUp.btn_name }}
                    </button>
                </div>
            </div>
        </Form>
        <div class="successMessage" v-if="!formVisible && !toManySendingMsg">
            <h3>{{ formSetUp.form_success_msg }}</h3>
        </div>
        <div class="to-many-requests-msg" v-if="toManySendingMsg">
            <span v-if="globalLang == ''">Вы отправили слишком много заявок, попробуйте позднее</span>
            <span v-if="globalLang == 'kz/'">Сіз жіберді тым көп өтінімдерді көріңіз кешіктірмей</span>
            <span v-if="globalLang == 'en/'">You have sent too many requests, please try again later</span>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { Form } from "vee-validate";
    import * as Yup from "yup";
    import TextInput from "@/components/forms/TextInput.vue";

    const NAME_REGEX  = /^([а-яА-ЯёЁa-zA-Z].*[\s.]*){3,35}$/;
    const PHONE_REGEX = /^\+7\s?\((700|701|702|703|704|705|706|707|708|709|747|771|775|776|777|778)\)\s?\d{3}-\d{2}-\d{2}$/;
    import turnstileMixin, { TURNSTILE_SITE_KEY } from '@/mixins/turnstile';

    export default {
        name: 'FormFieldsFlatCard',
        mixins: [turnstileMixin],
        data() {
            return {
                globalLang: window.GlobalLang,
                toManySendingMsg: false,
                phone: '',
                name: '',
                formVisible: true,
                formDisabled: false,
                utmUrlParams: {},
            }
        },
        components: {
            TextInput,
            Form,
        },
        computed: mapGetters({
            formSetUp: 'loadFormSetUp',
        }),
        setup() {
            const schema = Yup.object().shape({
                name: Yup.string()
                    .required('Title is required')
                    .matches(NAME_REGEX),
                phone: Yup.string()
                    .required('First Name is required')
                    .matches(PHONE_REGEX),
            });
            return { schema };
        },
        methods: {
            // Тройная защита: нет ошибок + поля не пусты + regex проходит
            isFormReady(errors, values) {
                const hasErrors = errors.name || errors.phone;
                if (hasErrors) return false;

                const name  = (values.name  || '').trim();
                const phone = (values.phone || '').trim();

                if (!name || !phone) return false;

                // Финальная проверка регулярками — на случай если vee-validate не успел
                if (!NAME_REGEX.test(name))  return false;
                if (!PHONE_REGEX.test(phone)) return false;

                return true;
            },

            onSubmit(values) {
                // Защита на уровне метода — форма не уйдёт с пустыми данными
                const name  = (values.name  || '').trim();
                const phone = (values.phone || '').trim();

                if (!name || !phone) {
                    console.warn('Попытка отправки с пустыми полями заблокирована');
                    return;
                }
                if (!NAME_REGEX.test(name) || !PHONE_REGEX.test(phone)) {
                    console.warn('Попытка отправки с невалидными данными заблокирована');
                    return;
                }

                this.name  = name;
                this.phone = phone;

                let submissionCounter = parseInt(localStorage.getItem('Benelux_submissionCounter') || '0');
                let lastSubmissionTime = parseInt(localStorage.getItem('Benelux_lastSubmissionTime') || '0');
                const currentMinutes = this.getCurrentMinutes();

                if (currentMinutes - lastSubmissionTime >= 5) {
                    submissionCounter = 0;
                }
                if (submissionCounter >= 5) {
                    this.toManySendingMsg = true;
                    return;
                }

                // this.getQueryParams(submissionCounter, lastSubmissionTime);
                this.withTurnstile(() => this.getQueryParams(submissionCounter, lastSubmissionTime));
            },

            getQueryParams(counter, time) {
                const urlParams = new URLSearchParams(window.location.search);
                for (const [key, value] of urlParams.entries()) {
                    this.utmUrlParams[key] = value;
                }
                this.sendData(counter, time);
            },

            sendData(counter, time) {
                // Последний рубеж — не отправляем если данные пусты или невалидны
                const name  = (this.name  || '').trim();
                const phone = this.normalizePhone(this.phone);

                if (!name || !phone) {
                    console.error('sendData: данные не прошли финальную проверку, отправка отменена');
                    return;
                }

                this.formDisabled = true;

                const dataForm = {
                    captcha:     this.turnstileToken,
                    captchaKey:  TURNSTILE_SITE_KEY,    
                    leadName: name,
                    phone: phone,
                    complex: 'Benelux',
                    email: '',
                    advertisingChannel: "199",
                    advertisingChannelCode: "199",
                    advertisingChannelName: "Сайт жилого комплекса",
                    leadChannelCode: 'WEBSITE_REST_PRIVATE_OFFICE',
                    leadChannelName: "Личный кабинет",
                    requestWebsite: 'benelux.bazis.kz',
                    description:
                        "Form on page" +
                        (this.utmUrlParams.utm_source    ? ` | Utm Source: ${this.utmUrlParams.utm_source}`    : '') +
                        (this.utmUrlParams.utm_medium    ? ` | Utm Medium: ${this.utmUrlParams.utm_medium}`    : '') +
                        (this.utmUrlParams.utm_campaign  ? ` | Utm Campaign: ${this.utmUrlParams.utm_campaign}` : '') +
                        (this.utmUrlParams.utm_content   ? ` | Utm Content: ${this.utmUrlParams.utm_content}`  : '') +
                        (this.utmUrlParams.utm_term      ? ` | Utm Term: ${this.utmUrlParams.utm_term}`        : ''),
                    utmSource:   this.utmUrlParams.utm_source   || '',
                    utmMedium:   this.utmUrlParams.utm_medium   || '',
                    utmCampaign: this.utmUrlParams.utm_campaign || '',
                    utmName:     this.utmUrlParams.utm_source   ? 'Сайт жилого комплекса - Benelux' : 'UTM отсутствует - Benelux',
                    utmContent:  this.utmUrlParams.utm_content  || '',
                    utmTerm:     this.utmUrlParams.utm_term     || '',
                    utmCode:     this.generateUniqueUTMCode(),
                };

                this.$store.dispatch('sendFormDataToCRM', dataForm).then((response) => {
                    if (response.status === 200) {
                        this.formVisible = false;
                        counter++;
                        localStorage.setItem('Benelux_submissionCounter', String(counter));
                        localStorage.setItem('Benelux_lastSubmissionTime', String(this.getCurrentMinutes()));
                        window.dataLayer.push({ event: 'form_sent' });
                    } else {
                        this.formDisabled = false;
                        this.resetTurnstile();
                        if (response && response.response && response.response.status === 429) {
                            this.toManySendingMsg = true;
                        } else {
                            console.warn('Ошибка при отправке формы - обратитесь в Call Center');
                        }
                    }
                });
            },

            normalizePhone(phone) {
                const digits = (phone || '').replace(/\D/g, '');
                if (digits.length !== 11 || !digits.startsWith('7')) return null;
                return `+7 ${digits.slice(1,4)} ${digits.slice(4,7)} ${digits.slice(7,9)} ${digits.slice(9,11)}`;
            },
            getCurrentMinutes() {
                return Math.floor(new Date().getTime() / (1000 * 60));
            },
            generateUniqueUTMCode() {
                const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
                const array = new Uint8Array(10);
                crypto.getRandomValues(array);
                return Array.from(array, b => chars[b % chars.length]).join('');
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/form-flat.scss';
    @import '@/styles/components/forms/form-fields-flat.scss';
</style>